import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import $session from "servicestack/session";
import shoppingConfig from "emun.shopping/shopping.config";
import orderConfig from "emun.order/order.config";
import labels from "emun.order/_labels";
import ServiceBus from "servicestack/service-bus";
const types = ["question", "incident", "problem", "task"];
const priorities = ["low", "normal", "high", "urgent"];
import Product from "emun.shopping/product.model";
import modals from "webmodals/modals";
import _ from "underscore";

const productSorter = scan => (a, b) => {
  const aI = a.id.indexOf(scan);
  const bI = b.id.indexOf(scan);
  if (aI === -1 && bI >= 0) return 1;
  if (bI === -1 && aI >= 0) return -1;
  if (aI >= 0 && bI >= 0 && aI > bI) return 1;
  if (aI >= 0 && bI >= 0 && bI > aI) return -1;
  if (bI === aI && aI >= 0) {
    const skuComp = skuLengthSorter(a, b);
    if (skuComp !== 0) return skuComp;
    return availableQtySorter(a, b);
  }
  return availableQtySorter(a, b);
};
const skuLengthSorter = (a, b) => {
  if (a.id.length > b.id.length) return 1;
  if (b.id.length > a.id.length) return -1;
  return 0;
};
const availableQtySorter = (a, b) => {
  if (a.availableQty > b.availableQty) return -1;
  if (b.availableQty > a.availableQty) return 1;
  return 0;
};

export default class TicketFieldsetController {
  constructor($geo) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.config = cartConfig;
    $ctrl.orderConfig = orderConfig;
    $ctrl.types = types;
    $ctrl.priorities = priorities;
    $ctrl.today = new Date().getTime();
    $ctrl.labels = labels;
    $ctrl.$geo = $geo;
    $ctrl.bus = new ServiceBus();
    $ctrl.prodQuery = new AutoQuery({
      url: "QueryProducts.json?V=Scan&IncludeInactive=1",
      autoLoad: false,
      criteria: {
//        CategoryId: 'FAN'
      },
      pageSize: 48,
      scrub: res =>
        (res.data.results = Product.map(
          res.data.results.sort(productSorter($ctrl.prodQuery.criteria.scan))
        )),
      onLoaded: args => $ctrl.productsLoaded(args)
    });
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.loadTicketFields();
  }

  loadTicketFields() {
    const $ctrl = this;
    $ctrl.bus
      .send("GetTicketFields.json")
      .then(function (res) {
        $ctrl.ticketFields = _.indexBy(res.data.ticket_fields, 'title');
        $ctrl.prodQuery.criteria.scan = $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Fan Model # (Primary)')].value;
        if ($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('EMUN Order')].value) {
          $ctrl.getEmunOrder($ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('EMUN Order')].value);
        }
        console.info("Country", $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Country')].value);
        if (!$ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Country')].value || $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Country')].value == undefined || $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Country')].value == "") {
          $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Country')].value = "US";
        }
      });
  }

  getEmunOrder(orderNumber) {
    const $ctrl = this;
    $ctrl.order = {};
    $ctrl.bus.send("QueryCarts.json?Id=" + orderNumber).then(function (res) {
      if (res.data.results.length > 0) {
        $ctrl.order = res.data.results[0];
        $ctrl.orderType = $ctrl.order.reasonCode;
        $ctrl.productType = $ctrl.order.vendorNote;
        $ctrl.shippingType = $ctrl.order.note;
      }
    });
  }

  getFieldIdByTitle(title) {
    const $ctrl = this;
    return $ctrl.ticketFields[title].id;
  }

  getFieldByTitle(title) {
    const $ctrl = this;
    var index = $ctrl.getFieldIndex($ctrl.ticketFields[title].id);
    return index;
  }

  getFieldIndex(id) {
    const $ctrl = this;
    var fieldIndex = -1;
    $ctrl.ticket.custom_fields.forEach(function (c, index) {
      if (c.id == id) {
        fieldIndex = index;
      }
    });
    return fieldIndex;
  }
  loadProducts() {
    const $ctrl = this;
    if (($ctrl.prodQuery.criteria.scan || "").length >= 1) {
      $ctrl.$selectedIndex = null;
      //$ctrl.product = null;
      $ctrl.prodQuery.load(true);
    } else {
      $ctrl.products = [];
    }
  }
  getProduct(id) {
    const $ctrl = this;
    if (id) {
      console.info("getProduct", id);
      $ctrl.prodQuery.bus.cancelAll();
      $ctrl.prodQuery.bus
        .read("QueryProducts.json", {
          cartId: $ctrl.$cart.cartId,
          id
        })
        .then(res => {
          if (res.data.results.length > 0) {
            $ctrl.setProduct(new Product(res.data.results[0]));
          }
        });
    }
  }
  productsLoaded(args) {
    const $ctrl = this;
    $ctrl.products = args.results;
    $ctrl.product = null;
    $ctrl.$lastScan = $ctrl.prodQuery.criteria.scan;
    if (
      args.results.length === 1 &&
      $ctrl.products[0].id === $ctrl.prodQuery.criteria.scan
    ) {
      $ctrl.setProduct(args.first);
    } else if (args.results.length == 0) {
      $ctrl.invalid = true;
    } else {
      $ctrl.$selectedIndex = 0;
    }
  }
  setProduct(p) {
    const $ctrl = this;
    console.info("setProduct", p);
    $ctrl.products = [];
    $ctrl.$selectedIndex = null;
    $ctrl.invalid = false;
    $ctrl.product = p;
    $ctrl.prodQuery.criteria.scan = p.id;
    $ctrl.ticket.custom_fields[$ctrl.getFieldByTitle('Fan Model # (Primary)')].value = p.id;
    if (($ctrl.product.meta["Status"] == "OB2" || $ctrl.product.meta["Status"] == "DIS" || $ctrl.product.meta["Status"] == "NFS") && $ctrl.product.onDemandProductEuid) {
      modals.alert("The model you have entered has been replaced by " + $ctrl.product.onDemandProductEuid + ".  Please update your records for future reference");
      $ctrl.getProduct($ctrl.product.onDemandProductEuid);
    } else if ($ctrl.product.meta["Status"] == "OB2") {
      modals.alert("The model you have entered is obsolete");
      $ctrl.product = {};
    }
  }

  applyAddress(address, model) {
    const $ctrl = this;
    var ac = $ctrl.$geo.addressMapper(address);
    //6console.info("BL*** ac = " + JSON.stringify(ac));
    if (ac.street_number && ac.route) {
      model.custom_fields[$ctrl.getFieldByTitle('Address')].value = ac.street_number + " " + ac.route;
      if (ac.neighborhood) model.custom_fields[$ctrl.getFieldByTitle('City')].value = ac.neighborhood;
      if (ac.locality) model.custom_fields[$ctrl.getFieldByTitle('City')].value = ac.locality;
      if (ac.administrative_area_level_1)
        model.custom_fields[$ctrl.getFieldByTitle('State')].value = ac.administrative_area_level_1;
      if (ac.postal_code)
        model.custom_fields[$ctrl.getFieldByTitle('Zip')].value = model.postalCode =
          ac.postal_code +
          (ac.postal_code_suffix ? "-" + ac.postal_code_suffix : "");
    }
    return ac;
  }


}
